import { render, staticRenderFns } from "./Xmsb.vue?vue&type=template&id=00742614&scoped=true&"
import script from "./Xmsb.vue?vue&type=script&lang=js&"
export * from "./Xmsb.vue?vue&type=script&lang=js&"
import style0 from "./Xmsb.vue?vue&type=style&index=0&id=00742614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00742614",
  null
  
)

export default component.exports